"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _stackdriverErrorsJs = _interopRequireDefault(require("stackdriver-errors-js"));
var _constants = require("../constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var errorHandler;
if (typeof window !== 'undefined' && ['production', 'staging', 'development'].includes(_constants.APP_ENV)) {
  errorHandler = new _stackdriverErrorsJs.default();
  errorHandler.start({
    key: _constants.GCP_ERROR_REPORTING_API_KEY,
    projectId: _constants.GCP_ERROR_REPORTING_PROJECT_ID,
    reportUncaughtExceptions: false,
    reportUnhandledPromiseRejections: false,
    service: "FB-UI (".concat(window.location.host, ")"),
    version: 'v2'
  });
} else {
  errorHandler = {
    report: console.error
  };
}
var _default = exports.default = errorHandler;